import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ButtonsModule, ComponentsModule, DialogModule, DialogService, FormFieldModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SettingsService } from '@lib/setting/settings.service';
import { createHandbackReasonFormGroup, HandbackReasonSingleResponse, StoreHandbackReasonRequest } from '@lib/api/models/setting';
import { DialogRef } from '@angular/cdk/dialog';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { FormValidationService } from '@shared/services/form-validation.service';

@Component({
    selector: 'app-add-handback-reason-dialog',
    imports: [
        ButtonsModule,
        DialogModule,
        ErrorPanelComponent,
        FormFieldModule,
        ReactiveFormsModule,
        ComponentsModule
    ],
    templateUrl: './add-handback-reason-dialog.component.html',
    standalone: true,
    styleUrl: './add-handback-reason-dialog.component.scss'
})
export class AddHandbackReasonDialogComponent {

    private readonly _settingsService = inject(SettingsService);
    private readonly _snackBar = inject(SnackBarService);
    private readonly _formValidationService = inject(FormValidationService);

    protected readonly handbackReasonFormGroup = createHandbackReasonFormGroup();

    protected readonly dialogRef = inject<DialogRef>(DialogRef);

    @Output() addCapacityEvent = new EventEmitter<string>();

    addHandbackReason = new SendableRequest<HandbackReasonSingleResponse, StoreHandbackReasonRequest>({
        request: payload => this._settingsService.createHandbackReason(payload!),

        onSuccess: () => {

            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Handback Reason created successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });

            this.addCapacityEvent.emit('added');
            this.dialogRef.close();
        }
    });

    add() {

        if (!this.handbackReasonFormGroup.valid) {

            this._formValidationService.markFormGroupTouched(this.handbackReasonFormGroup);

            this._formValidationService.showFormErrors(this.handbackReasonFormGroup, true);

            return;
        }

        this.addHandbackReason.send({
            name: this.handbackReasonFormGroup.value.name ?? '',
            description: this.handbackReasonFormGroup.value.description ?? '',
            status: true
        });
    }

    public static show(dialog: DialogService) {
        return dialog.openDialog<DialogRef>(AddHandbackReasonDialogComponent, {});
    }
}
